import { useCalendarStateStore } from "../store/use-calendar-state-store";

export const useCalendarFilters = () => {
  const { statusFilters, workerFilters, setStatusFilters, setWorkerFilters, clearCalendarFilters } =
    useCalendarStateStore();

  const hasActiveFilters = statusFilters.length > 0 || workerFilters.length > 0;

  return {
    statusFilters,
    workerFilters,
    setStatusFilters,
    setWorkerFilters,
    clearCalendarFilters,
    hasActiveFilters,
  };
};
